import { BarChart2, ChevronRight, Download, FileSpreadsheet, Wallet } from 'lucide-react';

export default function ViewBilan() {
  return (
    <div className='demo-view-enter space-y-8'>
      <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
        {[
          { v: '128', l: 'équipes', c: 'text-blue-600 dark:text-blue-400' },
          { v: '3 840 €', l: 'recettes', c: 'text-emerald-600 dark:text-emerald-400' },
          { v: '0', l: 'litige', c: 'text-amber-600 dark:text-amber-400' },
          { v: '4', l: 'exports', c: 'text-purple-600 dark:text-purple-400' },
        ].map(({ v, l, c }) => (
          <div
            key={l}
            className='bg-slate-50 border border-slate-200 dark:bg-slate-900 dark:border-slate-800 rounded-2xl p-5 text-center'
          >
            <p className={`text-2xl font-black ${c}`}>{v}</p>
            <p className='text-[11px] text-slate-500 mt-1'>{l}</p>
          </div>
        ))}
      </div>

      <div className='grid md:grid-cols-2 gap-6'>
        {/* Résultats */}
        <div>
          <p className='text-[10px] font-black text-slate-500 uppercase tracking-widest mb-4'>Podium</p>
          <div className='space-y-3'>
            {[
              { rank: '1er', emoji: '🥇', name: 'Dubois / Bernard', detail: 'Finale 13–9 · Terrain 2' },
              { rank: '2e', emoji: '🥈', name: 'Garcia / Lopez', detail: 'Finale 9–13 · Terrain 2' },
              { rank: '3e', emoji: '🥉', name: 'Petit / Morel', detail: 'Demi-finale · Terrain 4' },
            ].map(x => (
              <div
                key={x.rank}
                className='bg-white border border-slate-200 dark:bg-slate-900/60 dark:border-slate-800 rounded-2xl p-4 flex items-center gap-4'
              >
                <span className='text-2xl leading-none'>{x.emoji}</span>
                <div className='flex-1 min-w-0'>
                  <p className='font-bold text-slate-900 dark:text-white text-sm truncate'>{x.name}</p>
                  <p className='text-xs text-slate-500 dark:text-slate-400 mt-0.5'>
                    {x.rank} · {x.detail}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Exports + revenus */}
        <div>
          <p className='text-[10px] font-black text-slate-500 uppercase tracking-widest mb-4'>Exports & compta</p>

          <div className='space-y-3 mb-4'>
            {[
              { icon: FileSpreadsheet, title: 'Participants (CSV)', desc: 'Liste équipes + contacts + statut.' },
              { icon: Download, title: 'Paiements (CSV)', desc: 'Références Stripe + montants.' },
              { icon: BarChart2, title: 'Classement final (CSV)', desc: 'Rangs, équipes, ex-æquos.' },
            ].map(({ icon: Icon, title, desc }) => (
              <div
                key={title}
                className='bg-slate-50 border border-slate-200 dark:bg-slate-900/60 dark:border-slate-800 rounded-2xl p-4 flex items-center gap-3'
              >
                <div className='w-10 h-10 bg-slate-200 border border-slate-300 dark:bg-slate-800 dark:border-slate-700 rounded-2xl flex items-center justify-center shrink-0'>
                  <Icon className='w-4 h-4 text-slate-500 dark:text-slate-400' />
                </div>
                <div className='flex-1 min-w-0'>
                  <p className='font-bold text-slate-900 dark:text-white text-sm truncate'>{title}</p>
                  <p className='text-xs text-slate-500 dark:text-slate-400 mt-0.5'>{desc}</p>
                </div>
                <ChevronRight className='w-5 h-5 text-slate-400 dark:text-slate-600' />
              </div>
            ))}
          </div>

          <div className='bg-linear-to-r from-blue-600/20 to-indigo-600/20 border border-blue-500/25 rounded-2xl p-4 flex items-center justify-between'>
            <div className='flex items-center gap-2'>
              <Wallet className='w-4 h-4 text-blue-600 dark:text-blue-300' />
              <div>
                <p className='font-bold text-slate-900 dark:text-white text-sm'>Recettes concours</p>
                <p className='text-xs text-blue-600 dark:text-blue-300 mt-0.5'>Suivi Stripe + exports</p>
              </div>
            </div>
            <div className='text-right'>
              <p className='font-black text-slate-900 dark:text-white text-lg'>3 840 €</p>
            </div>
          </div>

          <div className='mt-3 text-[10px] text-slate-500 dark:text-slate-700 leading-relaxed'>
            Commission Partenaire BoulesConnect : 2 % + 0,30 € (min 0,75 €) par inscription payée · 0 € fixe · Concours
            illimités.
          </div>
        </div>
      </div>
    </div>
  );
}
